import { Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { APP_V2_USER_EVENTS, MuiMarkdown, useToast } from "@src/appV2/lib";
import { logEvent } from "@src/appV2/lib/analytics";

import { TextButton } from "../../components/TextButton";
import { useWorkplaceSummaryFeedbackStorage } from "./hooks/useWorkplaceSummaryFeedbackStorage";

interface Props {
  summaryId: string;
  summary: string;
  qualificationName: string;
  workplaceId: string;
}

export function WorkplaceReviewSummary(props: Props) {
  const { summaryId, summary, qualificationName, workplaceId } = props;

  const [hasProvidedFeedback, setHasProvidedFeedback] =
    useWorkplaceSummaryFeedbackStorage(summaryId);

  const { showSuccessToast } = useToast();

  return (
    <Stack gap={4} mt={8}>
      <Text
        variant="body1"
        sx={(theme) => ({
          fontWeight: theme.typography.fontWeightMedium,
        })}
      >
        Professionals say
      </Text>
      <MuiMarkdown forceBlock semibold variant="body2">
        {summary}
      </MuiMarkdown>
      <Text
        variant="body2"
        sx={(theme) => ({
          fontWeight: theme.typography.fontWeightMedium,
          color: theme.palette.text.tertiary,
        })}
      >
        AI generated from the text of workplace reviews
      </Text>
      {!hasProvidedFeedback && (
        <Stack direction="row" gap={6} alignItems="center">
          <Text
            variant="body2"
            sx={(theme) => ({
              fontWeight: theme.typography.fontWeightMedium,
              color: theme.palette.text.secondary,
            })}
          >
            Was this helpful?
          </Text>
          <Stack direction="row" gap={4}>
            <TextButton
              onClick={() => {
                logEvent(APP_V2_USER_EVENTS.WORKPLACE_REVIEW_SUMMARY_HELPFUL_CLICKED, {
                  qualificationName,
                  workplaceId,
                  summary,
                  summaryId,
                });
                showSuccessToast("Thank you for your feedback!");
                setHasProvidedFeedback(true);
              }}
            >
              Yes
            </TextButton>
            <TextButton
              onClick={() => {
                logEvent(APP_V2_USER_EVENTS.WORKPLACE_REVIEW_SUMMARY_NOT_HELPFUL_CLICKED, {
                  qualificationName,
                  workplaceId,
                  summary,
                  summaryId,
                });
                showSuccessToast("Thank you for your feedback!");
                setHasProvidedFeedback(true);
              }}
            >
              No
            </TextButton>
          </Stack>
        </Stack>
      )}
    </Stack>
  );
}
